module.exports = __webpack_public_path__ + "img/数据标准(2).161097b2.png";